import { css, keyframes } from '@emotion/react'
import type { ReactNode } from 'react'

const notificationBadgeRipple = keyframes({
  '0%': { transform: 'scale(.8)', opacity: 1 },
  '100%': { transform: 'scale(2.4)', opacity: 0 },
})

export type NotificationBadgeProps = {
  active?: boolean
  children: ReactNode
}

/**
 * Wraps content with an optional notification dot (top-right). No MUI dependency.
 */
export const NotificationBadge = ({
  children,
  active = false,
}: NotificationBadgeProps) => {
  if (!active) return <>{children}</>

  return (
    <span
      css={css({
        position: 'relative',
        display: 'inline-block',
      })}
    >
      {children}
      <span
        css={css({
          position: 'absolute',
          top: 0,
          right: 0,
          transform: 'translate(50%, -50%)',
          backgroundColor: 'var(--color-critical-default)',
          color: 'var(--color-critical-default)',
          boxShadow: '0 0 0 2px var(--color-background-alternative)',
          width: 12,
          height: 12,
          borderRadius: '50%',
          '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: `${notificationBadgeRipple} 1.2s infinite ease-in-out`,
            border: '1px solid currentColor',
            content: '""',
          },
        })}
        aria-hidden
      />
    </span>
  )
}
